import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface IdentificationState {
    /**
     * 用户已经进行过跑团认证则返回相应信息，否则返回null
     */
    apply: Team.Identification;
}
const m: Module<IdentificationState, RootState> = {
    namespaced: true,
    state: () => ({
        apply: {
            id: 0,
            user_id: 0,
            name: '',
            district_level: [],
            leader: '',
            mobile: '',
            start_date: '',
            mailing_address_list: [],
            mailing_address: '',
            description: '',
            image: [],
            is_lock: false, // 如果是true则不允许修改
        },
    }),
    mutations: {
        /**
         * 记录申请
         * @param {} apply 申请数据
         */
        setApply(state, apply) {
           state.apply = apply;
        },
    },
    actions: {
        /**
         * 获得战队申请信息
         * @param {} forceUpdate
         */
        async getIdentificationApply({ state, commit }, forceUpdate) {
            const response = await Vue.axios.get('/api/v1/running_group');
            const rdata = response.data;
            if (rdata.status === 0) {
                const data = rdata.data;
                if (data) {
                    data.district_level = [ data.district_level_1, data.district_level_2, data.district_level_3 ].filter((_) => _);
                    delete data.district_level_1;
                    delete data.district_level_2;
                    delete data.district_level_3;
                    data.mailing_address_list = [ data.mailing_address_1, data.mailing_address_2, data.mailing_address_3 ].filter((_) => _);
                    delete data.mailing_address_1;
                    delete data.mailing_address_2;
                    delete data.mailing_address_3;
                    data.image = data.image || [];
                    commit('setApply', data);
                }
            }
            return rdata;
        },
        /**
         * 申请创建战队
         * @param {} data 数据
         */
        async updateApply({ state, commit, dispatch }) {
            const apply = state.apply;
            const response = await Vue.axios.post('/api/v1/running_group', {
                ...apply,
                district_level_1: apply.district_level[0],
                district_level_2: apply.district_level[1],
                district_level_3: apply.district_level[2],
                mailing_address_1: apply.mailing_address_list[0],
                mailing_address_2: apply.mailing_address_list[1],
                mailing_address_3: apply.mailing_address_list[2],
                image_key: apply.image.map((image) => image.key),
            });
            const rdata = response.data;
            return rdata;
        },
    },
};
export default m;
